<template>
  <DashboardLayout>
    <div class="container">
      <h2 class="mb-3">My Tamil Digital Asset Contribution</h2>
      <!--My Assests-->
      <div class="card mt-2">
        <div class="card-body">
          <div class="text-right mb-2">
            <a
              href="https://classroom.google.com/c/NjkyNjYxNzAyOTIy?cjc=skjtxlk"
              target="_blank"
            >
              <i class="fas fa-info-circle"></i> How to produce quality digital
              documents
            </a>
          </div>
          <div class="table-responsive">
            <table class="table table-hovarable" id="tblValidateAssetes">
              <thead>
                <tr>
                  <th>Uploaded Date</th>
                  <th>File ID</th>
                  <th>Category</th>
                  <th>Sub Category</th>
                  <th>Files</th>
                  <th>Approve</th>
                  <th>Reject</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="asset in assets" :key="asset.id">
                  <td>{{ asset.registerDate }}</td>
                  <td>{{ asset.cid }}</td>
                  <td>{{ asset.mainCategory }}</td>
                  <td>{{ asset.subCategory }}</td>
                  <td>
                    <a
                      class="btn btn-secondary btn-sm"
                      :href="
                        'https://s3.ap-southeast-1.amazonaws.com/static.TamilData.org/' +
                          asset.cid +
                          '.pdf'
                      "
                      target="_blank"
                    >
                      View File
                    </a>
                  </td>
                  <td>
                    <span class="badge badge-success"
                      >{{ asset.approveCount }} Approves</span
                    >
                  </td>
                  <td>
                    <span class="badge badge-danger"
                      >{{ asset.rejectCount }} Rejects</span
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!--My Assests-->
    </div>
  </DashboardLayout>
</template>

<script>
import DashboardLayout from "../layouts/DashboardLayout";
import axios from "axios";

//Swal Alerts
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";

//Bootstrap and jQuery libraries
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";

//Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from "jquery";

export default {
  name: "accounts",
  data: () => ({
    email: "",
    assets: [],
    ipfsData: [],
  }),
  components: {
    DashboardLayout,
  },
  mounted() {
    this.email = localStorage.email;

    this.getCategoryData();
    this.getValidateAssetes();
  },
  methods: {
    getValidateAssetes() {
      let loader = this.$loading.show();
      const headers = {
        Authorization: "Bearer " + localStorage.token,
      };
      axios
        .get(
          "https://58p9hgeo1e.execute-api.ap-southeast-1.amazonaws.com/TamilData.org-prod/assets/by-user/?email=" +
            this.email,
          {
            headers: headers,
          }
        )
        .then((response) => {
          //console.log(response);
          const ipfsData = JSON.parse(localStorage.getItem("ipfsData"));
          const assests = response.data;
          const finalAssests = [];

          $.each(assests, function(key, value) {
            var categoryId = value.catId;
            var subCategoryId = value.subCatId;

            const category = getCategoryName(
              ipfsData,
              categoryId,
              subCategoryId
            );

            value["mainCategory"] = category["mainCategory"];
            value["subCategory"] = category["subCategory"];

            finalAssests.push(value);
          });

          this.assets = finalAssests;
        })
        .catch(function(error) {
          //console.log(error);
        })
        .finally(() => {
          $("#tblValidateAssetes").DataTable();
          loader.hide();
        });
    },
    getCategoryData() {
      $.getJSON("ipfs.json", function(json) {
        localStorage.setItem("ipfsData", JSON.stringify(json));
      });
    },
  },
};

function getCategoryName(jsonData, mainCategoryId, subCategoryId) {
  let mainCategoryText = "";
  let subCategoryText = "";
  for (let mainCategory of jsonData) {
    if (mainCategory.id == mainCategoryId) {
      mainCategoryText = mainCategory.text;
      mainCategoryText = mainCategoryText.split("|")[0];

      for (let subCategory of mainCategory.nodes) {
        if (subCategory.id == subCategoryId) {
          subCategoryText = subCategory.text;
          break;
        }
      }

      break;
    }
  }

  return {
    mainCategory: mainCategoryText,
    subCategory: subCategoryText,
  };
}
</script>

<style scoped>
#tblValidateAssetes {
  width: 100%;
}
#tblValidateAssetes td {
  vertical-align: middle;
}
</style>
